import { FlexColAlignCenterBoth } from 'components/primitives/flex';
import styled from 'styled-components';

interface Props {
  bookingStatus:
    | string
    | 'inquiry'
    | 'pre-approved'
    | 'edits-pending'
    | 'edits_pending'
    | 'ready-to-approve'
    | 'ready-for-approval'
    | 'ready_for_approval'
    | 'requested'
    | 'aboard'
    | 'ashore'
    | 'approved'
    | 'request-cancelled'
    | 'expired'
    | 'concluded'
    | 'disputed'
    | 'declined'
    | 'pending'
    | 'unverified'
    | 'cancelled'
    | 'available'
    | 'removed';
  bookingModification?: boolean;
}

const BookingBadge = ({ bookingStatus = 'approved', bookingModification = null }: Props) => (
  <BookingBadgeWrapper
    className={`bookingStatus-${bookingStatus} ${bookingModification ? 'hasBookingModification' : ''}`}
  >
    <BookingBadgeText>{bookingStatus.replace(/-/g, ' ').replace(/_/g, ' ')}</BookingBadgeText>
  </BookingBadgeWrapper>
);

export default BookingBadge;

const BookingBadgeWrapper = styled.div`
  border-radius: 3px;
  padding: 4px 5px 3px;
  display: inline-block;

  &.bookingStatus-inquiry {
    background-color: #f5ece4;
    color: #17233c;
  }

  &.bookingStatus-pre-approved,
  &.bookingStatus-pre_approved {
    background-color: #0e7873;
    color: #ffffff;
  }

  &.bookingStatus-edits-pending,
  &.bookingStatus-edits_pending {
    background-color: #eef3fb;
    color: #17233c;
  }

  &.hasBookingModification {
    background-color: #f4c064 !important;
  }

  &.bookingStatus-ready-to-approve,
  &.bookingStatus-ready-for-approval,
  &.bookingStatus-ready_for_approval {
    background-color: #f4c064;
    color: #17233c;
  }

  &.bookingStatus-requested {
    background-color: #f4c064;
    color: #17233c;
  }

  &.bookingStatus-aboard {
    background-color: #2a8500;
    color: #ffffff;
  }

  &.bookingStatus-ashore {
    background-color: #2a8500;
    color: #ffffff;
  }

  &.bookingStatus-approved {
    background-color: #0751c2;
    color: #ffffff;
  }

  &.bookingStatus-request-cancelled {
    background-color: #5e696a;
    color: #ffffff;
  }

  &.bookingStatus-expired {
    background-color: #84365d;
    color: #ffffff;
  }

  &.bookingStatus-concluded {
    background-color: #dbdfe5;
    color: #5e696a;
  }

  &.bookingStatus-disputed {
    background-color: #dbdfe5;
    color: #5e696a;
  }

  &.bookingStatus-declined {
    background-color: #5e696a;
    color: #ffffff;
  }

  &.bookingStatus-pending {
    background-color: #f5ece4;
    color: #17233c;
  }

  &.bookingStatus-unverified {
    background-color: #f5ece4;
    color: #17233c;
  }

  &.bookingStatus-cancelled {
    background-color: #5e696a;
    color: #ffffff;
  }

  // for captains
  &.bookingStatus-available {
    background-color: #f5ece4;
    color: #ffffff;
  }

  &.bookingStatus-removed {
    background-color: #5e696a;
    color: #ffffff;
  }
`;

const BookingBadgeText = styled(FlexColAlignCenterBoth)`
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
`;
